module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"collectable":"Colecionáveis","description":"Selecione um dos itens colecionáveis abaixo ou pule esta etapa clicando acima.","next":"Avançar","no-collectable-selected-error":"Você não selecionou nenhum item colecionável. Selecione um para avançar ou pule esta etapa.","skip":"Pular","title":"Vamos eternizar suas fotos?"}}')
  delete Component.options._Ctor
}
